module.exports = __webpack_public_path__ + "_assets/img/yl-yello-icon.607f5bcc.svg";